'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _FileInput = _interopRequireDefault(require("Components/Forms/Elements/FileInput"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step"));
var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _handleFileChange = _interopRequireDefault(require("Components/Forms/Functions/handleFileChange"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _options = require("Shared/options");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
class NewCompanyForm extends _react.Component {
  state = {
    status_messages: {},
    'company[acceptation]': false,
    'company[cgu_accepted]': false,
    activeStep: 0,
    skipped: []
  };
  handleChange = _handleChange.default.bind(this);
  handleFileChange = _handleFileChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCompanyActivity();
  }
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const company = (0, _getFormData.default)({
      state: state,
      pattern: 'company['
    });
    qwest.post('/company/create', company).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      component.login(response.login, response.pass, response.id);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCompanyActivity = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.setState({
      loading: true
    });
    qwest.post('/company-activity/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        company_activities: response.company_activities
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleCheckboxChange = _ref => {
    let {
      e,
      name,
      value
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  login = (login, pass, id) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/login', {
      login: login,
      password: pass
    }).then(function (xhr, response) {
      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      component.setState({
        loading: false
      });
      window.setTimeout(function () {
        app.navigateTo('/mon-compte-entreprise/' + id);
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        loading: false,
        ...(0, _getErrorsFromResponse.default)({
          response: response,
          error: DEFAULT_ERROR
        })
      });
    });
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  isStepSkipped = step => {
    const component = this,
      props = this.props,
      state = this.state;
    return state.skipped.includes(step);
  };
  handleNext = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    newSkipped.push(state.activeStep);
    component.setState({
      activeStep: state.activeStep + 1,
      skipped: newSkipped
    });
  };
  handleBack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let newSkipped = state.skipped;
    let prevStep = state.activeStep - 1;
    const index = newSkipped.indexOf(prevStep);
    if (index > -1) {
      newSkipped.splice(index, 1);
    }
    newSkipped.filter(function (step) {
      return step !== prevStep;
    });
    component.setState({
      activeStep: state.activeStep - 1,
      skipped: newSkipped
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let company_activities_options = (state.company_activities || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (company_activity) {
      let option = {
        label: company_activity.label,
        value: company_activity.id
      };
      return option;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/company/create"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form u-margin-top-10"
    }, "Coordonn\xE9es de la personne en charge du recrutement"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[lastname]'],
      name: "company[lastname]",
      type: "text",
      label: "Nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[firstname]'],
      name: "company[firstname]",
      type: "text",
      label: "Pr\xE9nom",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[profession]'],
      name: "company[profession]",
      type: "text",
      label: "Fonction dans l'entreprise",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[home_phone_number]'],
      name: "company[home_phone_number]",
      type: "text",
      label: "Num\xE9ro de t\xE9l\xE9phone fixe",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[phone_number]'],
      name: "company[phone_number]",
      type: "text",
      label: "Num\xE9ro de t\xE9l\xE9phone portable",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations de connexion"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[login]'],
      name: "company[login]",
      type: "text",
      label: "E-mail (login)",
      autocomplete: "new-email",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['company[password]'],
      name: "company[password]",
      type: "password",
      label: "Mot de passe",
      autocomplete: "new-password",
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes,
      className: "u-margin-top-10"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Informations sur l'entreprise"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Raison sociale de l'entreprise",
      onChange: component.handleChange,
      value: state['company[company_name]'],
      name: "company[company_name]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Code postal",
      onChange: component.handleChange,
      value: state['company[company_address][postal_code]'],
      name: "company[company_address][postal_code]",
      status: state.status_messages
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes,
      className: "u-margin-top-10"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Pr\xE9cision de la demande"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Acc\xE8s \xE0 CVtheque",
      name: "company[demand][cvtheque]",
      value: state['company[demand][cvtheque]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Cvth\xE8que d\xE9poser une annonce",
      name: "company[demand][create_ad]",
      value: state['company[demand][create_ad]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Conseil pour l\u2019int\xE9gration de collaborateurs Asperger",
      name: "company[demand][integration_help]",
      value: state['company[demand][integration_help]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Formation",
      name: "company[demand][formations]",
      value: state['company[demand][formations]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Sensibilisation",
      name: "company[demand][sensibilisation]",
      value: state['company[demand][sensibilisation]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Autre (d\xE9crire la demande)",
      name: "company[demand][other]",
      value: state['company[demand][other]'] === true,
      status: state.status_messages
    })), state['company[demand][other]'] === true ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Demande",
      onChange: component.handleChange,
      value: state['company[other_demand]'],
      name: "company[other_demand]",
      status: state.status_messages
    })) : undefined), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-margin-top-30"
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleChange,
      label: "J'accepte les conditions g\xE9n\xE9rales d'utilisation",
      name: "company[cgu_accepted]",
      value: state['company[cgu_accepted]'] === true,
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/pdf/CGU.pdf",
      target: "_blank",
      className: "u-margin-top-10 c-link"
    }, "Voir les CGU")), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, "Valider la cr\xE9ation de mon compte", loader)), status);
    return output;
  }
}
exports.default = NewCompanyForm;
